import { StyleSheet } from "react-native";
import colors from "@constants/color";
import metrics, { onboardingDimensions } from "@constants/metrics";

export default StyleSheet.create({
  container: {
    height: "100%",
    width: "100%",
  },
  userTopInfoContainer: {
    padding: 15,
  },
  userTopInfoWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  ordersWrapper: {
    padding: 10,
    flex: 1,
  },
  bottomContainer: {
    alignSelf: "center",
    height: onboardingDimensions.bottomContainerHeight,
    width: metrics.screenWidth,
    borderTopLeftRadius: metrics.screenHeight * 0.03,
    borderTopRightRadius: metrics.screenHeight * 0.03,
    marginTop: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 3,
    justifyContent: "center",
    alignItems: "center",
  },
  newOrderBtnWrapper: {
    position: "absolute",
    bottom: 0,
    backgroundColor: colors.primary,
    width: "100%",
    padding: 10,
  },
  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 20,
  },
  button: {
    height: metrics.screenHeight / 14,
    width: metrics.screenWidth / 2.3,
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  ordersHeader: {
    flexDirection: "row",
    paddingLeft: 23,
    paddingRight: 16,
    paddingTop: 30,
    paddingBottom: 3,
  },
});
